export class ContactIngestionApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Ingests a candidate file into an organization's contact pool.
     * @returns PersonIngestionJobResponse
     * @throws ApiError
     */
    process({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/contact-ingestion/process',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
